import React from 'react';
import { Star } from 'lucide-react';

const TestimonialCard = ({ name, role, quote, rating = 5, image }) => {
	return (
		<div className="bg-white rounded-xl p-6 shadow-md border border-gray-100">
			<div className="flex items-center mb-4">
				{image ? (
					<img src={image} alt={name} className="w-12 h-12 rounded-full mr-4 object-cover" loading="lazy" />
				) : (
					<div className="w-12 h-12 rounded-full mr-4 bg-gradient-to-br from-blue-500 to-purple-500 text-white flex items-center justify-center font-bold">
						{name?.[0]?.toUpperCase() || 'U'}
					</div>
				)}
				<div>
					<h4 className="font-bold text-gray-900">{name}</h4>
					<p className="text-sm text-gray-600">{role}</p>
				</div>
			</div>
			<div className="flex items-center mb-3">
				{Array.from({ length: rating }).map((_, i) => (
					<Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400 mr-1" />
				))}
			</div>
			<p className="text-gray-700 italic">“{quote}”</p>
		</div>
	);
};

export default TestimonialCard;


